import styled from 'styled-components';

import DIce from 'assets/tokens/dice-logo.svg';
import Ice from 'assets/tokens/ice-logo.svg';

import { cardBoxShadow, flexRowSpaceBetween, respondDown } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

export const Container = styled.aside`
    float: right;
    position: sticky;
    right: 10%;
    top: 2rem;
    padding: 4.5rem 5rem;
    border-radius: 0.5rem;
    background: ${COLORS.white};
    display: flex;
    flex-direction: column;
    margin-top: -18rem;
    z-index: 102;
    ${cardBoxShadow};

    ${respondDown(Breakpoints.lg)`
         float: unset;
         position: relative;
         width: calc(100% - 3.2rem);
         right: unset;
         margin: 1.6rem;
         box-shadow: unset;
    `};

    ${respondDown(Breakpoints.md)`
      padding: 3.2rem 1.6rem;
    `};
`;

export const Title = styled.span`
    font-weight: 700;
    font-size: 2rem;
    line-height: 2.8rem;
    color: ${COLORS.textPrimary};
    margin-bottom: 3.4rem;
`;

export const CreatePair = styled.div`
    font-size: 1.6rem;
    line-height: 2.8rem;
    color: ${COLORS.textSecondary};
    opacity: 0.7;
    max-width: 26rem;
    margin-bottom: 2.5rem;
`;

export const Row = styled.div`
    ${flexRowSpaceBetween};
    margin-bottom: 2rem;
    width: 26rem;

    ${respondDown(Breakpoints.md)`
         width: 100%;
    `}
`;

export const Label = styled.span`
    font-size: 1.4rem;
    line-height: 2rem;
    color: ${COLORS.textGray};
    display: flex;
    align-items: center;
`;

export const Value = styled.span`
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: ${COLORS.textTertiary};
    display: flex;
    align-items: center;
`;

export const PercentWithoutBoost = styled.span`
    color: ${COLORS.gray200};
`;

export const Divider = styled.div`
    border-bottom: 0.1rem solid ${COLORS.gray100};
    margin: 2.4rem 0;
    width: 100%;
`;

export const IceLogo = styled(Ice)`
    height: 1.6rem;
    width: 1.6rem;
    margin-right: 0.8rem;
`;

export const DIceLogo = styled(DIce)`
    height: 1.6rem;
    width: 1.6rem;
    margin-right: 0.8rem;
`;
